import { ITableTr } from 'app/shared/models/dynamic/table.interface';
import { createAction, props } from '@ngrx/store';
import { RiskUWApprovalDTO } from 'app/shared/models/data/dto/quick-quote/uw-approval.dto';

export const updateSubmissionUWRsIsLoadingFromUwApprovalSavingData = createAction(
  '[UwApprovalSavingData] Update Submission UWRs Is Loading',
  props<{ isLoading: boolean }>()
);

export const updateSubmissionUWRsListFromUwApprovalSavingData = createAction(
  '[UwApprovalSavingData] Update Submission UWRs List',
  props<{ list: RiskUWApprovalDTO[] }>()
);

export const updateSubmissionUWRsTableRowsFromUwApprovalData = createAction(
  '[UwApprovalData] Update Submission UWRs Table Rows',
  props<{ tableRows: ITableTr[] }>()
);